import * as React from "react";
import { styled } from "@mui/system";
import MUIIconButton from "@mui/material/IconButton";
import { IconButtonProps } from "@mui/material/IconButton";

export const IconButton = styled(
  React.forwardRef((props: IconButtonProps, ref: any) => (
    <MUIIconButton {...props} ref={ref} />
  )),
  {
    name: "IconButton",
    slot: "Root",
    overridesResolver: (props, styles) => [styles.root]
  }
)(({ theme }) => ({
  svg: {
    fontSize: "16px"
  },
  "&.MuiIconButton-root.MuiIconButton-sizeSmall": {
    maxWidth: 32,
    maxHeight: 32,
    minWidth: 32,
    minHeight: 32
  },
  "&.MuiIconButton-root.MuiIconButton-sizeMedium": {
    maxWidth: 40,
    maxHeight: 40,
    minWidth: 40,
    minHeight: 40
  },
  "&.MuiIconButton-root.MuiIconButton-sizeLarge": {
    padding: 0,
    minWidth: 48,
    minHeight: 48
  }
})) as IconButtonComponent;

type IconButtonComponent = (
  props: IconButtonProps &
    React.RefAttributes<HTMLDivElement> & { component?: React.ElementType }
) => JSX.Element;
